import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        textAlign: 'center',
      }}
    >
      <CancelIcon
        sx={{
          fontSize: 80,
          color: 'error.main',
          mb: 3,
        }}
      />
      <Typography variant="h4" component="h1" gutterBottom>
        Subscription Cancelled
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Your subscription payment was cancelled. You can try again or contact support if you need assistance.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate('/subscription')}
        >
          Try Again
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          onClick={() => navigate('/')}
        >
          Return to Home
        </Button>
      </Box>
    </Box>
  );
}

export default SubscriptionCancel; 